const customSelectors = {};

class customJS {
    constructor() {
    }
}

typeof customJS !== 'undefined' && new customJS();

console.log('GMC custom.js loaded');

/*
=========================================================
GIFTNOTE DEFAULT MODAL TEXT CUSTOMIZATION
=========================================================

Purpose:
Updates the default Giftnote app modal text after the app
injects the modal into the page.

Notes for developer:
- Giftnote appears to render this modal dynamically.
- This script retries after page load, after clicks, and watches
  DOM changes so the text is updated whenever the modal appears.
*/

(function () {
    function updateGiftnoteText() {
        const title = document.querySelector('#giftnote-modal-title');
        const description = document.querySelector('#giftnote-modal-description p');

        if (title) {
            title.textContent = 'Gifting has never been easier with Grill Masters Club!';
        }

        if (description) {
            description.textContent = "Add a custom gift message and choose when you'd like it delivered by email to your recipient.";
        }
    }

    // Run immediately
    updateGiftnoteText();

    // Run after normal page load events
    document.addEventListener('DOMContentLoaded', updateGiftnoteText);
    window.addEventListener('load', updateGiftnoteText);

    // Run shortly after clicks because Giftnote may inject/open the modal after a button click
    document.addEventListener('click', function () {
        setTimeout(updateGiftnoteText, 100);
        setTimeout(updateGiftnoteText, 500);
        setTimeout(updateGiftnoteText, 1000);
        setTimeout(updateGiftnoteText, 2000);
    });

    // Watch for Giftnote dynamically adding/replacing modal content
    const observer = new MutationObserver(function () {
        updateGiftnoteText();
    });

    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Safety retry for app-injected content
    let attempts = 0;
    const maxAttempts = 30;

    const retryInterval = setInterval(function () {
        attempts++;
        updateGiftnoteText();

        if (attempts >= maxAttempts) {
            clearInterval(retryInterval);
        }
    }, 500);
})();